import type { ReactNode } from "react";
import { useEffect, useState } from "react";

import { createPortal } from "react-dom";

import { getDefaultMountNode } from "./mountNode";

type PortalProps = {
  children: ReactNode;
  mountNode?: HTMLElement | null;
  open?: boolean;
};

/**
 * Renders children into the shared modal mount node (or document.body).
 * Keeps the historical `#modal-mount-node` contract used by App.
 */
export function Portal({ children, mountNode, open = true }: PortalProps) {
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setNode(mountNode ?? getDefaultMountNode());
  }, [mountNode]);

  if (!open || !node) {
    return null;
  }

  return createPortal(children, node);
}
